
import Modal from '@/components/Shared/Modal/index.vue'
import AdminContentEditable from '~/mixins/AdminContentEditable'
export default {
  mixins: [AdminContentEditable],
  components: {
    Modal
  },
  props: {
    index: {
      default: 1
    }
  },
  data() {
    return {
      newCertificateOrDiplomaText: "",
      showCertificateListModal: false,
      st: this.$store.state.settings.contents[this.$i18n.locale],
      certificates: [],
      updateCertificate: []
    }
  },
  methods: {
     array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
},
    ADD_CERTIFICATE(){
      if(this.newCertificateOrDiplomaText === '') return;
      this.updateCertificate.push({label: this.newCertificateOrDiplomaText});
      this.newCertificateOrDiplomaText = "";
    },
    UPDATE_CERTIFICATE(){
      this.newCertificateOrDiplomaText = "";
      this.updateCertificate = [...this.certificates.map(c => ({label: c}))];
      this.showCertificateListModal = true;
    },
    SAVE_CERTIFICATE(){
      const base_ul_start = "<ul class='lab-ul'>";
      const base_url_end = "</ul>";
      const htmlOfCertificate = this.updateCertificate.map(c => `<li>${c.label}</li>`).join('');
      const resultHtml = base_ul_start + htmlOfCertificate + base_url_end;
      this.updatedElements.push({
          req: "Contents/" + this.st[`about${this.index}`].id,
          key: 'degrees',
          type: 2,
          id: this.st[`about${this.index}`].id,
          text: resultHtml
      });
      this.SAVE_CONTEXT('PUT',
                    `Contents/${this.st[`about${this.index}`].id}`,
                    this.st[`about${this.index}`].id,
                    ['degrees'], this.CALLBACK_THAT_SAVED_CERTIFICATE)
    },
    CALLBACK_THAT_SAVED_CERTIFICATE() {
      this.certificates = this.updateCertificate.map(c => c.label);
      this.showCertificateListModal = false;
      this.newCertificateOrDiplomaText = ""
    },
    SAVE_CONTENT() {
      location.reload()
    },
  },
  mounted() {
    if (this.st[`about${this.index}`].degrees) {
      this.certificates =
        this.st[`about${this.index}`].degrees
          .replace(/<ul class='lab-ul'>/g, '')
          .replace(/<\/ul>/g, '')
          .replace(/<\/li>/g, '')
          .split('<li>')
          .filter((item, i) => i !== 0 && i < 4) || []
    } else this.certificates = [];
  },
}
